/**
 * Client helper that fetches the encrypted dspi/dsps and the dspk from the admin
 * portal over the internal gateway (two exact paths, GET, no cookies) and decrypts the
 * pair in the browser.
 */

import { getDspPairUrl, getDspKeyUrl } from './apiUrls';
import { decryptDspPair } from './cipher';

// Simple GET without custom headers or cookies: no CORS preflight, no session leak.
const getJson = (url) => fetch(url, { method: 'GET', credentials: 'omit', cache: 'no-store' });

/** Fetch the encrypted dspi/dsps and the dspk from the admin portal, then decrypt dspi/dsps. */
export const getDspPair = async () => {
  try {
    const [pairResponse, keyResponse] = await Promise.all([getJson(getDspPairUrl()), getJson(getDspKeyUrl())]);
    if (!pairResponse.ok || !keyResponse.ok) {
      const status = pairResponse.ok ? keyResponse.status : pairResponse.status;
      return { ok: false, dspi: '', dsps: '', status };
    }

    const [pair, key] = await Promise.all([pairResponse.json(), keyResponse.json()]);
    if (!pair || !pair.dspi || !pair.dsps || !key || !key.dspk) {
      return { ok: false, dspi: '', dsps: '', status: pairResponse.status };
    }

    const { dspi, dsps } = await decryptDspPair(key.dspk, pair);
    return { ok: Boolean(dspi && dsps), dspi, dsps, status: pairResponse.status };
  } catch (error) {
    return { ok: false, dspi: '', dsps: '', status: 0 };
  }
};

export default getDspPair;
